import { createSelectorCreator, defaultMemoize } from 'reselect';
import get from 'lodash.get';
import isEqual from 'lodash.isequal';

// GLobal Types
import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { selectHarvestEventsQuantityScheduleTotalsByDate } from '../../../../selectors';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

interface Props {
    date: string;
}

const selectDate = (state: AppState, props: Props): string => props.date;

const makeSelectQuantitySchedulesTotalForDate = (): any =>
    createDeepEqualSelector(
        [selectHarvestEventsQuantityScheduleTotalsByDate, selectDate],
        (harvestEventQuantityScheduleTotalsByDateState, dateState: any) =>
            get(harvestEventQuantityScheduleTotalsByDateState, dateState, 0)
    );

export { makeSelectQuantitySchedulesTotalForDate };
